// extracted by mini-css-extract-plugin
module.exports = {"badge":"sM","isRental":"sN","badgeWrapper":"sO","hide":"sP","roundedBadge":"sQ","gridBadge":"sR"};